import { Emptyable, FormType } from "@simplyk/common";

import { isDevelopment, isStaging } from "../constants/env";

type WindowWithDataLayer = Window & {
  dataLayer?: Record<string, unknown>[];
};

declare const window: WindowWithDataLayer;

declare global {
  interface Window {
    gtag?: (
      event: "event",
      name: string,
      data: { event_category: string; value: number; event_label: string; non_interaction: boolean }
    ) => void;
  }
}

const logGtmEvent = (payload: Record<string, unknown>) => {
  if (isStaging || isDevelopment) {
    // eslint-disable-next-line no-console
    console.log("GTM event", { ...payload });
  }
};

export const pushGtmConsentUpdated = () => {
  const payload = {
    event: "consent_updated",
  };
  window.dataLayer?.push(payload);

  logGtmEvent(payload);
};

export const pushGtmLocalisation = (payload: { country_code: string; region_code: string }) =>
  pushAndLogGtmEvent({
    event: "localisation_resolved",
    ...payload,
  });

export const isGtmBlocked = () => {
  return !window.dataLayer || !window.dataLayer.push || typeof window.dataLayer.push !== "function";
};

export const pushAndLogGtmEvent = (payload: Record<string, unknown>) => {
  if (typeof window !== "undefined") {
    if (!Array.isArray(window.dataLayer)) {
      window.dataLayer = [];
    }
    window.dataLayer.push(payload);
  }

  logGtmEvent(payload);
};

export const pushGtmFormInputChanged = (count: number) =>
  pushAndLogGtmEvent({
    event: "form_input_changed",
    form_input_changed_count: count,
  });

export const pushGtmFormView = (payload: {
  formId: Emptyable<string>;
  formPath: Emptyable<string>;
  organizationId: Emptyable<string>;
  formType: Emptyable<FormType>;
}) =>
  pushAndLogGtmEvent({
    event: "form_view",
    ...payload,
  });

export const pushGtmForethoughtUserContext = (payload: {
  email_zeffy: string;
  user_id_zeffy: string;
  org_id_zeffy: string;
  org_id_hubspot: string | null;
  chat_token_zeffy: string | null;
}) =>
  pushAndLogGtmEvent({
    event: "forethought_user_context",
    ...payload,
  });

export const pushGtmDonorSupportChannel = (payload: { donor_support_channel: "forethought" | "assistant" }) =>
  pushAndLogGtmEvent({
    event: "donor_support_channel_resolved",
    ...payload,
  });

export const pushGtmCommandSubmittedSuccessfully = (payload: {
  organization_id: string;
  form_id: string;
  form_type: string;
  form_category: string;
  amount: number;
  extra_donation: number;
  currency?: string;
  transaction_id: string;
}) => {
  pushAndLogGtmEvent({
    event: "command_submitted_successfully",
    ...payload,
  });
};
